import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import { createBrowserHistory } from 'history';

import General from '../containers/Views/Landing/General.jsx';
import ChildHealthPlus from '../containers/Views/Landing/ChildHealthPlus';
import Essential from '../containers/Views/Landing/Essential';
import IndividualsFamilies from '../containers/Views/Landing/IndividualsFamilies';
import Medicaid from '../containers/Views/Landing/Medicaid';
import Medicare from '../containers/Views/Landing/Medicare';
import SmallBusiness from '../containers/Views/Landing/SmallBusiness';
import SmallBusinessMarket from '../containers/Views/Landing/SmallBusinessMarket';
import GovernmentPrograms from '../containers/Views/Landing/GovernmentPrograms';
import SelfFunded from '../containers/Views/WhitePapers/SelfFunded';
import SimplySelfFunded from '../containers/Views/Landing/SimplySelfFunded';
import MedicareCompare from '../containers/Views/Landing/MedicareCompare';
import MedicareCompareWesternNY from '../containers/Views/Landing/MedicareCompareWesternNY';
import MedicareWesternNY from '../containers/Views/Landing/MedicareWesternNY';
import MedicareCompareUpgrade from '../containers/Views/Landing/MedicareCompareUpgrade';
import Selection from '../components/Questions/Selection.jsx';
import Quiz from '../containers/Views/Quiz.jsx';
import Quote from '../containers/Views/Quote.jsx';

import {quizPaths} from '../helpers/quiz';

export const history = createBrowserHistory();

export const checkURLParams = (url) => {
  let srchObj = (_.isObject(url) && _.isObject(url.location) ? url : window);
  const queryString = require('querystringify');
  const parsed = queryString.parse(srchObj.location.search);
  // console.log(parsed);
  // console.log(srchObj.location.search);

  if (parsed.utm_source || parsed.utm_medium || parsed.utm_campaign || parsed.utm_content || parsed.ppckw || parsed.intlink || parsed.gclid) {
    let leadCampaign = parsed.utm_campaign ? parsed.utm_campaign : '';
    let leadMedium = parsed.utm_medium ? parsed.utm_medium : '';
    let leadSource = parsed.utm_source ? parsed.utm_source : '';
    let leadContent = parsed.utm_content ? parsed.utm_content : '';
    let leadKeyword = parsed.keyword ? parsed.keyword : '';
    let leadInternalSource = parsed.intlink ? parsed.intlink : '';
    let leadGCLID = parsed.gclid ? parsed.gclid : '';
    let lead = {leadCampaign, leadMedium, leadSource, leadContent, leadKeyword, leadInternalSource, leadGCLID};
    const cookies = new Cookies();
    cookies.set('CDPHP_Marketing_Campaign_Source', lead, { path: '/' });
    console.log(lead);
  }
};

export const pageDefaults = {
  'meta': {
    'title': 'Health Insurance Plans for Families and Businesses from CDPHP',
    'description': 'Good health starts here, with a top-rated plan. Physicals and preventive screenings at no cost to you, local customer support, and much more.',
    'canonical': 'https://plans.cdphp.com/'
  },
  'header': {
    'phone': '866-692-3747',
    'hours': 'M-F, 8:30 a.m. - 5 p.m.'
  },
  'banner': {
    'heading': 'Find the right plan.',
    'subhead': 'Good health starts here.',
    'links': [
    ]
  },
  'guide': {
    'title': '',
    'area': 'IndividualGuide'
  },
  'notice': {
    'question': 'Not quite ready to shop?',
    'intro': 'Read',
    'title': 'The Top 5 Mistakes People Make When Selecting a Health Insurance Plan',
    'url': '/guide'
  },
  'show': {
    'guide': false,
    'ynm': false,
    'options': false,
    'options1': false,
    'options2': false,
    'options3': false,
    'triplezero': false,
    'fivestars': false,
    'upstateny': false,
    'optionsoffer': false,
    'banner': true,
    'notice': false,
    'ratings': true,
    'header': true,
    'footer': true,
    'results': false
  },
  'view': {
    'class': General,
    'props': {},
    'url': '/'
  },
  'inQuiz': false
};

export const quizDefaults = {
  'page': {
    'show': {
      'startOver': false,
      'banner': false,
      'notice': false,
      'ratings': false,
      'footer': false
    },
    'inQuiz': true
  }
};

export const resultsDefaults = {
  'page': {
    'show': {
      'startOver': false,
      'banner': false,
      'notice': false,
      'ratings': false,
      'footer': false
    },
    'inQuiz': true
  }
};

const _generalLanding = {
  'page': {
    'header': {
      'phone': '866-692-3747'
    },
    'banner': {
      'heading': 'Find the right plan.',
      'subhead': 'Good health starts here.',
      'links': [
        <Link
          key='ind'
          to='/individuals/find-a-plan/start'
          className='btn'
        >For Just Me</Link>,
        <Link
          key='fam'
          to='/families/find-a-plan/start'
          className='btn'
        >For My Family</Link>,
        <Link
          key='biz'
          to='/small-business/find-a-plan/start'
          className='btn'
        >For My Employees</Link>
      ]
    },
    'show': {
      'ratings': 'true',
      'footer': 'true',
      'ratingsProps': {
        'jdpower': 'true',
        'homepage': 'true'
      },
      'footerProps': {
        'jdpower': 'true',
        'medicare': 'true'
      }
    }
  }
};

const _medicareLanding = {
  'page': {
    'meta': {
      'title': 'Top-Rated Medicare Advantage Plans from CDPHP',
      'description': 'Good health starts here, with a top-rated plan. A national network of doctors and hospitals, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/whitepaper/medicare/'
    },
    'header': {
      'phone': '888-519-7898 | TTY: 711',
      'hours': ['M-F, 8 a.m. – 8 p.m.', <sup key='icon'>‡</sup>]
    },
    'banner': {
      'heading': 'Find the right Medicare\u00A0plan.',
      'subhead': 'Your good health, now starting at $0.',
      'styles': {},
      'links': [
        <Link
          key='medicare'
          to='/medicare/find-a-plan/start'
          className='btn'>Get Started</Link>
      ]
    },
    'guide': {
      'title': 'The Top 5 Mistakes People Make When Selecting a Medicare Plan',
      'area': 'MedicareGuide'
    },
    'notice': {
      'question': 'Just starting your research?',
      'intro': 'Download the',
      'title': 'Top 5 Mistakes People Make When Selecting a Medicare Plan',
      'url': '/medicare/guide'
    },
    'ynm': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptionsYesNoMaybe'
    },
    'options': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptions'
    },
    'options1': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptions1'
    },
    'options2': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptions2'
    },
    'options3': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptions3'
    },
    'triplezero': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareTripleZero'
    },
    'fivestars': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareFiveStars'
    },
    'upstateny': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareUpstateNY'
    },
    'optionsoffer': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptionsOffer'
    },
    'view': {
      'url': '/medicare/',
      'class': Medicare,
      'props': {}
    },
    'show': {
      'notice': true,
      'ratingsProps': {
        'medicare': 'true'
      },
      'footerProps': {
        'medicare': 'true',
        'medicareHours': 'true'
      }
    }
  }
};

const _medicareWesternNY = {
  'page': {
    'meta': {
      'title': 'Top-Rated Medicare Advantage Plans from CDPHP',
      'description': 'Good health starts here, with a top-rated plan. A national network of doctors and hospitals, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/whitepaper/medicare-western-ny/'
    },
    'header': {
      'phone': '585-895-7733 | TTY: 711',
      'hours': ['M-F, 8 a.m. – 8 p.m.', <sup key='icon'>‡</sup>]
    },
    'banner': {
      'heading': 'Find the right Medicare\u00A0plan.',
      'subhead': 'Your good health, now starting at $0.',
      'styles': {},
      'className': 'western',
      'links': [
        <Link
          key='medicare'
          to='/medicare/find-a-plan/start'
          className='btn'>Get Started</Link>
      ]
    },
    'guide': {
      'title': 'The Top 5 Mistakes People Make When Selecting a Medicare Plan',
      'area': 'MedicareGuide'
    },
    'notice': {
      'question': 'Just starting your research?',
      'intro': 'Download the',
      'title': 'Top 5 Mistakes People Make When Selecting a Medicare Plan',
      'url': '/medicare-western-ny/guide'
    },
    'options': {
      'title': 'Medicare Advantage: Plan Options guide',
      'area': 'MedicareOptionsWesternNY'
    },
    'view': {
      'url': '/medicare-western-ny/',
      'class': MedicareWesternNY,
      'props': {}
    },
    'show': {
      'ratingsProps': {
        'medicare': 'true'
      },
      'footerProps': {
        'medicare': 'true',
        'medicareHours': 'true'
      }
    }
  }
};

const _medicareCompare = {
  'page': {
    'meta': {
      'title': 'Compare Our Most Popular Medicare Advantage Plans',
      'description': 'Good health starts here, with a top-rated plan. A national network of doctors and hospitals, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/whitepaper/medicare-compare/'
    },
    'show': {
      'header': false,
      'banner': false,
      'notice': false,
      'ratings': true,
      'footer': true,
      'ratingsProps': {
        'medicare': 'true'
      },
      'footerProps': {
        'medicare': 'true',
        'medicareHours': 'true'
      }
    },
    'header': {
      'phone': '888-519-7898 | TTY: 711',
      'hours': ['M-F, 8 a.m. – 8 p.m.', <sup key='icon'>‡</sup>]
    },
    'view': {
      'url': '/medicare-compare/',
      'class': MedicareCompare,
      'props': {}
    }
  }
};

const _medicareCompareUpgrade = {
  'page': {
    'meta': {
      'title': 'Compare Our Most Popular Medicare Advantage Plans',
      'description': 'Good health starts here, with a top-rated plan. A national network of doctors and hospitals, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/medicare/2027'
    },
    'show': {
      'header': false,
      'banner': false,
      'notice': false,
      'ratings': true,
      'footer': true,
      'ratingsProps': {
        'medicare': 'true'
      },
      'footerProps': {
        'medicare': 'true',
        'medicareHours': 'true'
      }
    },
    'header': {
      'phone': '888-519-7898 | TTY: 711',
      'hours': ['M-F, 8 a.m. – 8 p.m.', <sup key='icon'>‡</sup>]
    },
    'view': {
      'url': '/medicare/2027',
      'class': MedicareCompareUpgrade,
      'props': {}
    }
  }
};

const _medicareCompareWNY = {
  'page': {
    'meta': {
      'title': 'Compare Our Most Popular Medicare Advantage Plans',
      'description': 'Good health starts here, with a top-rated plan. A national network of doctors and hospitals, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/whitepaper/medicare-compare-western-ny/'
    },
    'show': {
      'header': false,
      'banner': false,
      'notice': false,
      'ratings': true,
      'footer': true,
      'ratingsProps': {
        'medicare': 'true'
      },
      'footerProps': {
        'medicare': 'true',
        'medicareHours': 'true'
      }
    },
    'header': {
      'phone': '585-895-7733 | TTY: 711',
      'hours': ['M-F, 8 a.m. – 8 p.m.', <sup key='icon'>‡</sup>]
    },
    'view': {
      'url': '/medicare-compare-western-ny/',
      'class': MedicareCompareWesternNY,
      'props': {}
    }
  }
};

const _smallBusinessLanding = {
  'page': {
    'meta': {
      'title': 'Health Insurance Plans for Small Businesses from CDPHP',
      'description': 'Physicals and preventive screenings at no cost to you, low co-pays, free gyms, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/whitepaper/small-business/'
    },
    'header': {
      'phone': '866-242-8830',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'banner': {
      'heading': 'Find the right plan for your business.',
      'subhead': 'Good health starts here.',
      'links': [
        <Link
          key='smb'
          to='/small-business/find-a-plan/start'
          className='btn'>Get Started</Link>
      ]
    },
    'guide': {
      'title': '',
      'area': 'EmployerGuide'
    },
    'notice': {
      'title': 'The Top 5 Mistakes Companies Make When Selecting a Health Plan',
      'url': '/small-business/guide'
    },
    'view': {
      'url': '/small-business/',
      'class': SmallBusiness,
      'props': {}
    },
    'show': {
      'ratingsProps': {
        'smallbiz': 'true'
      },
      'footerProps': {
        'smallbiz': 'true',
        'jdpower': 'true'
      }
    }
  }
};

const _smallBusinessLandingLookAgain = {
  'page': {
    'meta': {
      'title': 'Health Insurance Plans for Small Businesses from CDPHP',
      'description': 'Physicals and preventive screenings at no cost to you, low co-pays, free gyms, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/whitepaper/small-business-look-again'
    },
    'header': {
      'phone': '866-242-8830',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'banner': {
      'heading': 'Return to a plan that combines innovation, value, and convenience.',
      'subhead': 'Good health starts here.',
      'className': 'lookagain',
      'links': [
        <Link
          key='smb'
          to='/small-business-look-again/find-a-plan/start'
          className='btn'>Get Started</Link>
      ]
    },
    'guide': {
      'title': '',
      'area': 'EmployerGuide'
    },
    'notice': {
      'title': 'The Top 5 Mistakes Companies Make When Selecting a Health Plan',
      'url': '/small-business-look-again/guide'
    },
    'view': {
      'url': '/small-business-look-again/',
      'class': SmallBusiness,
      'props': {
        'lookagain': 'true',
        'tab': 'small'
      }
    },
    'show': {
      'ratingsProps': {
        'smallbiz': 'true'
      },
      'footerProps': {
        'smallbiz': 'true',
        'jdpower': 'true'
      }
    }
  }
};

const _smallBusinessHudsonValley = {
  'page': {
    'meta': {
      'title': 'Healthy starts with CDPHP',
      'description': 'Explore fresh, new employee health care coverage options in the Hudson Valley.',
      'canonical': 'https://plans.cdphp.com/hudson-valley'
    },
    'header': {
      'phone': '866-242-8830',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'banner': {
      'heading': 'Healthy starts with CDPHP.',
      'subhead': 'Explore fresh, new employee health care coverage options in the Hudson Valley.'
    },
    'view': {
      'url': '/hudson-valley/',
      'class': SmallBusinessMarket,
      'props': {
        'tab': 'small'
      }
    },
    'show': {
      'notice': false,
      'ratingsProps': {
        'smallbiz': 'true'
      },
      'footerProps': {
        'smallbiz': 'true',
        'jdpower': 'true'
      }
    }
  }
};

const _individualsFamiliesLanding = {
  'page': {
    'meta': {
      'title': 'Health Insurance Plans for Individuals and Families from CDPHP'
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. - 5 p.m.'
    },
    'banner': {
      'subhead': 'Good health starts here.',
      'links': [
        <Link
          key='ind-fam'
          to='/individuals/find-a-plan/start'
          className='btn'>For Just Me</Link>,
        <Link
          key='fam'
          to='/families/find-a-plan/start'
          className='btn'>For My Family</Link>
      ]
    },
    'notice': {
      'title': 'The Top 5 Mistakes People Make When Selecting a Health Insurance Plan',
      'url': '/individuals-families/guide'
    },
    'view': {
      'url': '/individuals-families/',
      'class': IndividualsFamilies,
      'props': {}
    }
  }
};

const _medicaidLanding = {
  'page': {
    'meta': {
      'title': 'Medicaid Plans from CDPHP',
      'description': 'Good health starts here, with a top-rated plan. Find out if you qualify – sign up any time, there’s no open enrollment period.',
      'canonical': 'https://plans.cdphp.com/medicaid'
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. - 5 p.m.'
    },
    'banner': {
      'heading': 'Find out if you qualify for a Medicaid plan.',
      'subhead': 'Good health starts here.',
      'links': [
        <Link
          key='medicaid'
          to='/medicaid/find-a-plan/zip?skip=true'
          className='btn'>For Just Me</Link>,
        <Link
          key='medicaid-fam'
          to='/medicaid/family/find-a-plan/start'
          params={{ family: 'hello' }}
          className='btn'>For My Family</Link>
      ]
    },
    'notice': {
      'title': 'The Top 5 Mistakes Companies Make When Selecting a Health Plan',
      'url': '/medicaid/guide'
    },
    'view': {
      'url': '/medicaid/',
      'class': Medicaid,
      'props': {}
    },
    'show': {
      'ratingsProps': {
        'medicaid': 'true'
      },
      'footerProps': {
        'medicaid': 'true'
        // 'jdpower': 'true'
      }
    }
  }
};

const _childHealthPlusLanding = {
  'page': {
    'meta': {
      'title': 'Child Health Plus (CHP) Plans from CDPHP',
      'description': 'Good health starts here, with a top-rated plan. Find out if your children qualify – sign up any time, there’s no open enrollment period.',
      'canonical': 'https://plans.cdphp.com/child-health-plus'
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. - 5 p.m.'
    },
    'banner': {
      'heading': ['Find out if your children qualify ', <br key='1' />, ' for a Child Health Plus plan.'],
      'subhead': 'Get health care that works for your family.',
      'styles': {},
      'links': [
        <Link
          key='chp'
          to='/child-health-plus/find-a-plan/start'
          className='btn'>Get Started</Link>
      ]
    },
    'notice': {
      'title': 'The Top 5 Mistakes People Make When Selecting a Health Insurance Plan',
      'url': '/child-health-plus/guide'
    },
    'view': {
      'url': '/child-health-plus/',
      'class': ChildHealthPlus,
      'props': {}
    }
  }
};

const _essentialLanding = {
  'page': {
    'meta': {
      'title': 'Essential Plans from CDPHP',
      'description': 'Find out if you qualify for a $0 or $20 Essential Plan from CDPHP – sign up any time, there’s no open enrollment period.',
      'canonical': 'https://plans.cdphp.com/essential'
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'banner': {
      'heading': 'Find out if you qualify for an Essential Plan.',
      'subhead': 'Your good health, now at $0 per month.',
      'links': [
        <Link
          key='essential'
          to='/essential/find-a-plan/zip?skip=true'
          className='btn'>For Just Me</Link>,
        <Link
          key='essential-fam'
          to='/essential/family/find-a-plan/start'
          params={{ family: 'hello' }}
          className='btn'>For My Family</Link>
      ]
    },
    'notice': {
      'title': 'The Top 5 Mistakes People Make When Selecting a Health Insurance Plan',
      'url': '/essential/guide'
    },
    'view': {
      'url': '/essential/',
      'class': Essential,
      'props': {}
    }
  }
};

const _findPlanLanding = {
  'page': {
    'meta': {
      'title': 'Find the Right CDPHP Plan'
    },
    'show': {
      'startOver': false,
      'banner': false,
      'notice': false,
      'ratings': false,
      'footer': false
    },
    'view': {
      'url': '/find-a-plan/',
      'class': Selection,
      'props': {}
    },
    'inQuiz': true
  }
};

const _governmentProgramsLanding = {
  'page': {
    'meta': {
      'title': 'Health Insurance Plans for Individuals and Families from CDPHP.',
      'description': 'Good health starts here, with a top-rated plan. Physicals and preventive screenings at no cost to you, local customer support, and much more.',
      'canonical': 'https://plans.cdphp.com/government-programs'
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'banner': {
      'heading': 'Find out if you qualify for a plan starting at $0.',
      'subhead': 'Good health starts here.',
      'links': [
        <Link
          key='ind-fam'
          to='/individuals/find-a-plan/start'
          className='btn'>For Just Me</Link>,
        <Link
          key='fam'
          to='/families/find-a-plan/start'
          className='btn'>For My Family</Link>
      ]
    },
    'notice': {
      'title': 'The Top 5 Mistakes People Make When Selecting a Health Insurance Plan',
      'url': '/government-programs/guide'
    },
    'view': {
      'url': '/government-programs/',
      'class': GovernmentPrograms,
      'props': {}
    },
    'show': {
      'ratingsProps': {
        'government': 'true'
      },
      'footerProps': {
        'government': 'true'
        // 'jdpower': 'true'
      }
    }
  }
};

// const _needLanding = {
//   'page': {
//     'meta': {
//       'title': 'For all your health needs, turn to CDPHP.',
//       'description': 'Good health starts here, with a top-rated plan. Physicals and preventive screenings at no cost to you, local customer support, and much more.'
//     },
//     'show': {
//       'banner': false,
//       'notice': false,
//       'ratings': false,
//       'footer': true
//     },
//     'header': {
//       'phone': '866-692-3747',
//       'hours': 'M-F, 8:30 a.m. – 5 p.m.'
//     },
//     'view': {
//       'url': '/need/',
//       'class': NeedLanding,
//       'props': {}
//     }
//   }
// };

const _whitePaperSelfFunded = {
  'page': {
    'meta': {
      'title': 'Is a Self-Funded Health Plan Right For Your Business?',
      'description': 'Explore the benefits of self-funding for organizations big and small.',
      'canonical': 'https://plans.cdphp.com/whitepaper/self-funded'
    },
    'show': {
      'header': false,
      'banner': false,
      'notice': false,
      'ratings': false,
      'footer': true
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'view': {
      'url': '/whitepaper/self-funded',
      'class': SelfFunded,
      'props': {}
    }
  }
};

const _simplySelfFundedLanding = {
  'page': {
    'meta': {
      'title': 'Simply Self-Funded℠ from CDPHP',
      'description': 'The smarter way to self-fund—no learning curve required.',
      'canonical': 'https://plans.cdphp.com/simply-self-funded'
    },
    'show': {
      'header': false,
      'banner': false,
      'notice': false,
      'ratings': false,
      'footer': true
    },
    'header': {
      'phone': '866-692-3747',
      'hours': 'M-F, 8:30 a.m. – 5 p.m.'
    },
    'view': {
      'url': '/simply-self-funded',
      'class': SimplySelfFunded,
      'props': {}
    }
  }
};

const _getPageValuesForLanding = (route, subroute) => {
  let state = {
    'page': pageDefaults
  };

  switch (route) {
    case 'guide':
      state = _.merge({}, state, {
        'page': {
          'show': {
            'guide': true
          },
          'view': {
            'props': {
              'modal': true
            }
          }
        }
      });
      break;

    case 'medicare':
      if (subroute === '2027') {
        state = _.merge({}, state, _medicareCompareUpgrade);
      } else {
        state = _.merge({}, state, _medicareLanding);
      }
      break;

    case 'medicare-western-ny':
      state = _.merge({}, state, _medicareWesternNY);
      break;

    case 'small-business':
      state = _.merge({}, state, _smallBusinessLanding);
      break;

    case 'small-business-look-again':
      state = _.merge({}, state, _smallBusinessLandingLookAgain);
      break;

    case 'hudson-valley':
      state = _.merge({}, state, _smallBusinessHudsonValley);
      if (subroute === 'large') {
        state = _.merge({}, state, {
          'page': {
            'view': {
              'props': {
                'tab': 'large'
              }
            }
          }
        });
      }
      break;

    case 'individuals-families':
      state = _.merge({}, state, _individualsFamiliesLanding);
      break;

    case 'medicaid':
      state = _.merge({}, state, _medicaidLanding);

      if (subroute === 'family') {
        state = _.merge({}, state, {
          'page': {
            'show': {
              'modal': true
            },
            'view': {
              'props': {
                'family': true
              }
            }
          }
        });
      }
      break;

    case 'child-health-plus':
      state = _.merge({}, state, _childHealthPlusLanding);
      break;

    case 'essential':
      state = _.merge({}, state, _essentialLanding);
      break;

    case 'government-programs':
      state = _.merge({}, state, _governmentProgramsLanding);
      break;

    case 'whitepapers':
      state = _.merge({}, state, _whitePaperSelfFunded);
      break;

    case 'simply-self-funded':
      state = _.merge({}, state, _simplySelfFundedLanding);
      break;

    // case 'need':
    //   state = _.merge({}, state, _needLanding);
    //   break;

    case 'medicare-compare':
      state = _.merge({}, state, _medicareCompare);
      break;

    case 'medicare-compare-western-ny':
      state = _.merge({}, state, _medicareCompareWNY);
      break;

    case 'find-a-plan':
      state = _.merge({}, state, _findPlanLanding);
      break;

    default:
      state = _.merge({}, state, _generalLanding);
      break;
  }

  if (subroute === 'guide') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'guide': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'yesnomaybe') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'ynm': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'options') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'options': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'options1') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'options1': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'options2') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'options2': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'options3') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'options3': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'triplezero') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'triplezero': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'fivestars') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'fivestars': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'upstateny') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'upstateny': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  if (subroute === 'optionsoffer') {
    state = _.merge({}, state, {
      'page': {
        'show': {
          'optionsoffer': true
        },
        'view': {
          'props': {
            'modal': true
          }
        }
      }
    });
  }

  return state;
};

const _getPageValuesForQuiz = (route, subroute) => {
  let state = _.merge({}, {
    'page': _.merge({}, pageDefaults, {
      'meta': {
        'title': 'Find the Right CDPHP Plan'
      },
      'view': {
        'class': Quiz
      }
    })
  }, quizDefaults);

  switch (route) {
    case 'find-a-plan': // FindPlan
      state = _.merge({}, state, {});
      break;

    case 'medicare': // FindPlanMedicare
      state = _.merge({}, state, {
        'countyKey': 'Medicare',
        'page': {
          'header': {
            'phone': '888-519-7898 | TTY: 711',
            'hours': 'M-F, 8 a.m. – 8 p.m.'
          }
        }
      });
      break;

    case 'medicaid': // FindPlan
      state = _.merge({}, state, {
        'countyKey': 'Medicaid',
        'page': {
          'header': {
            'phone': '866-692-3747',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'individuals': // FindPlanIndividuals
      state = _.merge({}, state, {
        'countyKey': 'Individual',
        'page': {
          'header': {
            'phone': '866-692-3747',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'individuals-families': // FindPlan
      state = _.merge({}, state, {
        'countyKey': 'IndividualsFamilies',
        'page': {
          'header': {
            'phone': '866-692-3747',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'families': // FindPlanFamilies
      state = _.merge({}, state, {
        'countyKey': 'Families',
        'page': {
          'header': {
            'phone': '866-692-3747',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'essential': // FindPlanEssential
      state = _.merge({}, state, {
        'countyKey': 'Essential',
        'page': {
          'header': {
            'phone': '866-692-3747',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'child-health-plus': // FindPlan
      state = _.merge({}, state, {
        'countyKey': 'ChildHealthPlus',
        'page': {
          'header': {
            'phone': '866-692-3747',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'small-business': // FindPlanSmallBusiness
      state = _.merge({}, state, {
        'countyKey': 'SmallBusiness',
        'page': {
          'header': {
            'phone': '866-242-8830',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    case 'small-business-look-again': // FindPlanSmallBusiness
      state = _.merge({}, state, {
        'countyKey': 'SmallBusiness',
        'page': {
          'header': {
            'phone': '866-242-8830',
            'hours': 'M-F, 8:30 a.m. - 5 p.m.'
          }
        }
      });
      break;

    default: // FindPlan
      state = _.merge({}, state, {
      });
      break;
  }

  return state;
};

const _getPageValuesForResults = (route) => {
  let state = _.merge({}, {
    'page': _.merge({}, pageDefaults, {
      'view': {
        'class': Quote
      }
    })
  }, resultsDefaults);

  if (route === 'quote') return state;
};

const _rewriteUrlWithNewValueAtIndex = (idx, val, path = window.location.pathname) => {
  const splitUrl = path.split('/');
  splitUrl[idx] = val;
  return splitUrl.join('/');
};

// Allow /medicare/guide for the notice modal; keep other medicare popup deep-links redirected.
export const MEDICARE_SUBSLUGS = [
  'ynm', 'options', 'options1', 'options2', 'options3', 'triplezero', 'fivestars', 'upstateny', 'optionsoffer'
];

export const setVarsBasedOnRoute = (route, subroute) => {
  if (route === 'medicare' && subroute && MEDICARE_SUBSLUGS.includes(subroute)) {
    history.replace({
      pathname: '/medicare/',
      search: window.location.search,
      hash: window.location.hash
    });
    subroute = undefined;
  }

  // Redirect the previous year's Medicare compare-upgrade page to the current one.
  if (route === 'medicare' && subroute === '2026') {
    history.replace({
      pathname: '/medicare/2027',
      search: window.location.search,
      hash: window.location.hash
    });
    subroute = '2027';
  }

  // Retired Western NY landing/compare pages: send everything to the main Medicare page.
  if (route === 'medicare-western-ny' || route === 'medicare-compare-western-ny') {
    history.replace({
      pathname: '/medicare/',
      search: window.location.search,
      hash: window.location.hash
    });
    route = 'medicare';
    subroute = undefined;
  }

  const CTA = <Link to={'/' + route + '/find-a-plan/start'} className='btn'>Find a Plan</Link>;

  let state = {
    'page': pageDefaults,
    CTA,
    route,
    subroute,
    'showResults': false
  };

  if (!_.isUndefined(route)) {
    if (route !== '/' && route !== 'home' && (
      subroute === 'find-a-plan' || subroute === 'family' || subroute === 'my-quote')
    ) {
      state = _.merge({}, state, _getPageValuesForQuiz(route, subroute));
    } else if (route === 'quote') { // Shorthand quote page (fills out quote values)
      state = _.merge({}, state, _getPageValuesForResults(route));
    } else { // User is accessing a landing page (possibly with a modal overlay):
      state = _.merge({}, state, _getPageValuesForLanding(route, subroute));
    }
  } else {
    state = _.merge({}, state, _getPageValuesForLanding(route, subroute));
  }

  return state;
};

export const getPathIndexFromUrl = (str, path = window.location.pathname) => (
  path.split('/').indexOf(str)
);

export const getPathValFromIndex = (idx, path = window.location.pathname) => (
  path.split('/')[idx]
);

export const getStepNameFromNum = (num, path = window.location.pathname, routeName) => {
  if (parseFloat(num) === 1) return 'start';
  const pathIdx = getPathIndexFromUrl('find-a-plan', path);
  const route = _.isUndefined(routeName) ? (getPathValFromIndex(pathIdx - 1) === 'family' ?
    getPathValFromIndex(pathIdx - 2) : getPathValFromIndex(pathIdx - 1)) : routeName;

  if (_.isObject(quizPaths[route])) {
    if (quizPaths[route].hasOwnProperty('steps')) {
      const routeSteps = quizPaths[route].steps;
      if (num > routeSteps.length) return 'results';
      return routeSteps[num - 1].key;
    }
  }
};

export const newStepIndexForUrl = (step, path = window.location.pathname) => {
  const pathIdx = getPathIndexFromUrl('find-a-plan', path);
  const stepIndex = pathIdx + 1;
  const newStepName = getStepNameFromNum(step, path);
  return _rewriteUrlWithNewValueAtIndex(stepIndex, newStepName, path).replace(/\/\//g, '/');
};

export const updateStepIfDifferent = (step) => {
  if (String(window.localStorage.getItem('lastStep')) !== String(step)) {
    window.localStorage.setItem('lastStep', String(step));
    history.push(newStepIndexForUrl(step));
  }
};

export const getStepNumberFromRouteAndId = (rt, id) => (
  // quizPaths[rt].steps.findIndex(o => o.key === id) + 1);
  quizPaths[rt].steps.map((o) => o.key).indexOf(id) + 1);

export const getStepNumberFromPath = (path = window.location.pathname) => {
  const pathIdx = getPathIndexFromUrl('find-a-plan', path);
  const route = getPathValFromIndex(pathIdx - 1) === 'family' ?
    getPathValFromIndex(pathIdx - 2) : getPathValFromIndex(pathIdx - 1);
  const step = getPathValFromIndex(pathIdx + 1);
  return getStepNumberFromRouteAndId(route, step);
};